import * as React from 'react';
import { SVGProps } from 'react';

const IconHomeSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 7v3.5a.5.5 0 0 0 .5.5H5V8h2v3h1.5a.5.5 0 0 0 .5-.5V7h1.496c.44 0 .668-.544.367-.876l-4.497-4.96a.491.491 0 0 0-.732 0l-4.497 4.96c-.301.332-.074.876.366.876H3Z" />
  </svg>
);
export default IconHomeSizeXs;
